// src/actions/intro_vids_actions.js
import { fetchIntroVidsAPI } from '../util/intro_vids_api_util';

/** --------- Constants --------- */
export const INTRO_VIDS_REQUEST = 'INTRO_VIDS_REQUEST';
export const INTRO_VIDS_SUCCESS = 'INTRO_VIDS_SUCCESS';
export const INTRO_VIDS_ERROR   = 'INTRO_VIDS_ERROR';
export const INTRO_VIDS_CLEAR_ERRORS = 'INTRO_VIDS_CLEAR_ERRORS';

/** --------- Action creators --------- */
export const introVidsRequest = () => ({
  type: INTRO_VIDS_REQUEST,
});

export const introVidsSuccess = (payload) => ({
  type: INTRO_VIDS_SUCCESS,
  payload,
});

export const introVidsError = (error) => ({
  type: INTRO_VIDS_ERROR,
  error,
});

export const clearIntroVidsErrors = () => ({
  type: INTRO_VIDS_CLEAR_ERRORS,
});

/** --------- Thunks --------- */
export const fetchIntroVids = () => async (dispatch) => {
  dispatch(introVidsRequest());
  try {
    const data = await fetchIntroVidsAPI();
    dispatch(introVidsSuccess(data));
  } catch (err) {
    dispatch(introVidsError(err.message || 'Failed to fetch intro vids'));
  }
};
